import UserOpportunitiesView from "../../components/opportunity/overview/user/UserOpportunitiesView";

const  MyOpportunitiesPage = () => {
  return <UserOpportunitiesView />;
};

export default MyOpportunitiesPage;
